import { Component, Input, OnInit, HostListener } from "@angular/core";
import { OwlOptions } from "ngx-owl-carousel-o";
import { BaseService } from "../../base.service";

@Component({
  selector: "app-partner-content",
  templateUrl: "./partner-content.component.html",
  styleUrls: ["./partner-content.component.css"],
})
export class PartnerContentComponent implements OnInit {
  @Input() content: any;
  constructor(private service: BaseService) {}
  simmerStatus = true;
  param = { limit: 7, offset: 0 };
  partnerData = [];
  carouselStatus: boolean = true;
  toprated: OwlOptions = {
    loop: false,
    autoplay: false,
    mouseDrag: true,
    autoWidth: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    smartSpeed: 1,
    skip_validateItems: true,
    navText: ["", ""],
    responsive: {
      0: {
        items: 2.4,
      },
      380: {
        items: 2.1,
      },
      450: {
        items: 4.1,
      },
      650: {
        items: 5.1,
      },
      910: {
        items: 7.1,
      },
      1108: {
        items: 8.1,
      },
      1230: {
        items: 10.1,
      },
      1257: {
        items: 10.1,
      },
    },
    nav: true,
  };
  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.carouselStatus = false;
    setTimeout(() => {
      this.carouselStatus = true;
    }, 100);
  }
  ngOnInit(): void {
    this.getPartnerData();
  }
  getPartnerData() {
    this.service.partnerList(this.param).subscribe(
      (data: any) => {
        if (data.results.length > 0) {
          this.service.contentPopular = true;
          this.partnerData = data.results;
          this.simmerStatus = false;
        } else {
          this.simmerStatus = false;
        }
      },
      (err) => {
        if (err) {
          setTimeout(() => {
            this.simmerStatus = false;
          }, 3000);
          // this.toastr.error(err.error.message);
        }
      }
    );
  }
}
